export default {
      id: "h-02-usage",
      viewBox: "0 0 276 287",
      url: __webpack_public_path__ + "assets/img/svg/sprite.svg#h-02",
      toString: function () {
        return this.url;
      }
    }